/**
 * Created by Tal on 7/24/17.
 */
import React from 'react'
import profilePic from '../data/profilePic.png'

const MyPic = () => (
    <div>
        <img src={profilePic} alt='tal' className='profile-pic' style = {{ height: '80px', width: '70px', borderRadius: '50%'}}/>
    </div>
)

export default MyPic


// WEBPACK FOOTER //
// ./src/components/MyPic.js